import { render, staticRenderFns } from "./ParentInfoRow.vue?vue&type=template&id=7a5632dd&scoped=true"
import script from "./ParentInfoRow.vue?vue&type=script&lang=ts"
export * from "./ParentInfoRow.vue?vue&type=script&lang=ts"
import style0 from "./ParentInfoRow.vue?vue&type=style&index=0&id=7a5632dd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5632dd",
  null
  
)

export default component.exports